import { Box, Grid, Typography, useTheme } from "@mui/material";
import React from "react";
import PaginationButtonPrevious from "../input/pagination/PaginationButtonPrevious";
import PaginationButtonNext from "../input/pagination/PaginationButtonNext";
import PaymentBox from "../dataitem/PaymentBox";
import dayjs from "dayjs";
import { paymentTypeMap } from "../../helpers/mapping";

const CalendarSeason = ({
    selectedSeason,
    onPrevSeasonClick,
    onNextSeasonClick,
    disablePrev,
    disableNext,
    payments,
    mt = 0
}) => {

    const theme = useTheme();
    const paymentTypes = paymentTypeMap();

    const numPayments = 1 + Object.keys(payments.monthlyFee).length + payments.otherPayments.length;
    const pbColXs = numPayments / 3;
    const pbColSm = numPayments / 4;
    const pbColMd = numPayments / 6;

    return (
        <React.Fragment>
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={theme.spacing(mt)}>
                <PaginationButtonPrevious
                    forceMobile={true}
                    onClick={onPrevSeasonClick}
                    disabled={disablePrev} />
                <Box sx={{ textAlign: "center" }}>
                    <Typography sx={{fontSize: "1.1rem", fontWeight: "bold"}}>{selectedSeason.seasonAcronym}</Typography>
                    <Typography sx={{fontSize: "0.75rem" }}>{selectedSeason.echelonName}</Typography>
                </Box>
                <PaginationButtonNext
                    forceMobile={true}
                    onClick={onNextSeasonClick}
                    disabled={disableNext} />
            </Box>
            <Grid container columns={numPayments} mt={theme.spacing(1)} alignItems="center" textAlign="center" spacing={theme.spacing(1)}>
                <Grid item xs={pbColXs} sm={pbColSm} md={pbColMd} textAlign="center">
                    <PaymentBox
                        paymentStatus={payments.initialFee.paymentStatus}
                        label={paymentTypes.ECHELON_INIT}
                        amount={payments.initialFee.amount} />
                </Grid>
                {
                    Object.keys(payments.monthlyFee).map((key) => {
                        const payment = payments.monthlyFee[key];
                        return (
                            <Grid item key={key} xs={pbColXs} sm={pbColSm} md={pbColMd} textAlign="center">
                                {
                                    payment && (
                                        <PaymentBox
                                            paymentStatus={payment.paymentStatus}
                                            label={dayjs(new Date(payment.paymentYear, payment.paymentMonth - 1, 1)).format("MMM YY")}
                                            amount={payment.amount} />
                                    )
                                }
                            </Grid>
                        )
                    })
                }
                {
                    payments.otherPayments.map((payment, index) => {
                        return (
                            <Grid key={index} item xs={pbColXs} sm={pbColSm} md={pbColMd} textAlign="center">
                                <PaymentBox
                                    paymentStatus={payment.paymentStatus}
                                    label={payment.label ?? paymentTypes.ECHELON_OTH}
                                    amount={payment.amount} />
                            </Grid>
                        )
                    })
                }
            </Grid>
        </React.Fragment>
    )
}

export default CalendarSeason;
